module.exports = __webpack_public_path__ + "media/images/icons/SVG/034-5c95dc99b74161b53ea2ee88a731d3dd.svg";